import { findIndex, replace } from 'lodash';
import { ICustomListData } from 'pages/ListManagement/types';
import { IRetailer } from 'shared/types';

export const eanValidator =
    (allowEmpty: boolean = false) =>
    (value: any, cb: (valid: boolean) => void) => {
        const pattern = /^(?=\S)(\d{4,20}|\d{2,}_\w+)$/;
        if (value === null || (allowEmpty && value === '')) {
            cb(true);
        } else {
            cb(value ? pattern.test(value.toString()) : false);
        }
    };

export const listValidator =
    (list: string[], allowEmpty: boolean = false) =>
    (value: string, cb: (valid: boolean) => void) => {
        if (allowEmpty && value === '') {
            cb(true);
        } else cb(list.includes(value));
    };

export const retailerValidator =
    (list: ICustomListData[], allowEmpty: boolean = false) =>
    (value: number, cb: (valid: boolean) => void) => {
        if (allowEmpty && !value) {
            cb(true);
        } else {
            cb(findIndex(list, (o) => o.id === value) !== -1);
        }
    };

const checkForFlat = (input: number): boolean => {
    return input % 1 !== 0;
};

export const numberValidator =
    (
        allowEmpty: boolean = false,
        limit?: {
            min?: number;
            max?: number;
        },
    ) =>
    (value: string, cb: (valid: boolean) => void) => {
        const newValue = replace(value, ' ', '');
        if (newValue === null || (allowEmpty && newValue === '')) {
            cb(true);
        } else if (newValue === '') {
            cb(false);
        } else {
            const intValue = Number(newValue);

            if (!Number.isNaN(intValue) && (Number.isInteger(intValue) || checkForFlat(intValue))) {
                if (limit) {
                    if (typeof limit.max === 'number' && intValue > limit.max) cb(false);
                    else if (typeof limit.min === 'number' && intValue < limit.min) cb(false);
                    else cb(true);
                } else {
                    cb(true);
                }
            } else {
                cb(false);
            }
        }
    };

export const stringValidator =
    (allowEmpty: boolean = false) =>
    (value: string, cb: (valid: boolean) => void) => {
        if (value === null || (!allowEmpty && value === '')) {
            cb(false);
        } else cb(true);
    };

export const stringIdValidator =
    (allowEmpty: boolean = false) =>
    (value: string, cb: (valid: boolean) => void) => {
        if (value === null || (!allowEmpty && value === '')) {
            cb(false);
        } else {
            const regex = /^[\d,]+$/;
            cb(regex.test(value));
        }
    };
